import { Controller } from "stimulus"

export default class extends Controller {
  static values = {
    maxHeight: Number,
  }

  connect() {
    this.expanded = false
    this.appendShowMoreLink()
    this.refresh()
  }

  appendShowMoreLink() {
    this.showMoreLink = document.createElement('a')
    this.showMoreLink.href = '#'
    this.showMoreLink.innerText = "Show more..."
    this.showMoreLink.style.display = 'none'
    this.showMoreLink.addEventListener('click', (e) => {
      e.preventDefault()
      this.expand()
    })
    // this.element.appendChild(this.showMoreLink)
    // Add outside of element
    this.element.parentNode.insertBefore(this.showMoreLink, this.element.nextSibling)
  }

  refresh() {
    const maxHeight = this.maxHeightValue
    const actualHeight = this.element.scrollHeight
    console.log({ maxHeight, actualHeight })

    const isOverflowing = actualHeight > maxHeight
    if (isOverflowing) {
      this.element.style.maxHeight = `${maxHeight}px`
      this.element.style.overflow = 'hidden'
      this.showMoreLink.style.display = 'block'
    }
  }

  expand() {
    this.element.style.maxHeight = 'none'
    this.element.style.overflow = 'visible'
    this.showMoreLink.style.display = 'none'
    this.expanded = true
  }

}
